// @flow

import * as React from 'react';
import Badge from 'sail/Badge';
import Group from 'sail/Group';
import {Heading} from 'sail/Text';
import './Card.scss';

export type CardBadgeDefinition = string | {|text: string, color?: string|};

type CardBadgeProps = {|
  badge: CardBadgeDefinition,
|};

export const CardBadge = ({badge}: CardBadgeProps) => {
  if (typeof badge === 'string') {
    return <Badge label={badge} />;
  } else {
    // $FlowExpectedError color wants a specific string but we just have a generic one
    return <Badge label={badge.text} color={badge.color ?? undefined} />;
  }
};

type CardHeaderProps = {|
  badge?: CardBadgeDefinition,
  text: string,
|};

export const CardHeader = ({badge, text}: CardHeaderProps) => (
  <Group
    direction="horizontal"
    spacing={4}
    alignItems="center"
    className="Card-title"
    padding={{bottom: 4}}
  >
    <Heading className="Card-title-text" color="blue" weight={500} size={16}>
      {text}
    </Heading>
    {badge && <CardBadge badge={badge} />}
  </Group>
);
